module.exports = __webpack_public_path__ + "fontawesome-webfont-4b5a84aaf1c9485e060c503a0ff8cadb.woff2";